import type { IssueSeverity } from '@/shared/constants/issue-status'

/**
 * The Dashboard tab's staged multi-select filter — every chart toggles values into it, the KPI cards
 * recompute over it, and "Show issues" writes it to the board store. One array per dimension (`[]` =
 * that dimension is unfiltered). Taluka is intentionally NOT here — it stays the page-level `?mandal=`
 * scope that already re-scopes the whole dashboard. `hod`/`site` hold department names / site names
 * (the values the issue feed carries).
 */
export interface DashFilter {
  age: string[]
  severity: IssueSeverity[]
  category: string[]
  department: string[]
  hod: string[]
  site: string[]
}

export const EMPTY_DASH_FILTER: DashFilter = {
  age: [],
  severity: [],
  category: [],
  department: [],
  hod: [],
  site: [],
}

/** The dimensions that hold plain string values (everything except the typed `severity`). */
export type DashFilterStringDim = 'age' | 'category' | 'department' | 'hod' | 'site'

export const dashFilterActive = (f: DashFilter): boolean =>
  f.age.length +
    f.severity.length +
    f.category.length +
    f.department.length +
    f.hod.length +
    f.site.length >
  0
